export const iconSet = {
  angleDown: 'assets/icons/angle-down-solid.svg',
  angleUp: 'assets/icons/angle-up-solid.svg',
  api: 'assets/icons/tower-broadcast-solid.svg',
  application: 'assets/icons/chart-simple-solid.svg',
  arrowRightBracket: 'assets/icons/arrow-right-from-bracket-solid.svg',
  cancel: 'assets/icons/xmark-solid.svg',
  configuration: 'assets/icons/diagram-project-solid.svg',
  create: 'assets/icons/plus-solid.svg',
  criticalError: 'assets/icons/fire-solid.svg',
  custom: 'assets/icons/wrench-solid.svg',
  delete: 'assets/icons/trash-can-solid.svg',
  domain: 'assets/icons/book-solid.svg',
  edit: 'assets/icons/pen-to-square-solid.svg',
  error: 'assets/icons/xmark-solid.svg',
  export: 'assets/icons/download-solid.svg',
  infrastructure: 'assets/icons/database-solid.svg',
  loading: 'assets/icons/circle-notch-solid.svg',
  settings: 'assets/icons/gear-solid.svg',
  view: 'assets/icons/eye-solid.svg',
}
